import { formatCurrency } from '../utils/FormatCurrency';
import { track, reset } from './mixpanel';

/**
 * Track when a user adds a product to cart DONE
 */
export function trackAddToCart(product) {
  track('add_to_cart', {
    product_id: product?.productID,
    product_name: product?.productName,
    price: product?.fairAppPrice,
    category: product?.produtCategory?.parent_category.name,
    sub_category: product?.produtCategory?.name,
    quantity: product?.quantity ?? 1,
  });
}

/**
 * Track when a user adds a product to cart DONE
 */
export function trackAddToFavorite(product) {
  track('add_to_favorite', {
    product_id: product?.productID,
    product_name: product?.productName,
    price: product?.fairAppPrice,
    sales_price: product?.fairAppfairAppSalesPrice,
    category: product?.produtCategory?.parent_category.name,
    sub_category: product?.produtCategory?.name,
    quantity: product?.quantity ?? 1,
  });
}

/**
 * Track when a user search a product  DONE
 */
export function trackProductSearched(query) {
  track('product_searched', {
    product_searched: query,
  });
}

/**
 * Track user signup event DONE
 */
export function trackSignUp(user) {
  track('sign_up', {
    user_id: user?.userID,
    email: user?.email,
    phone_number: user?.phoneNumber,
    method: user?.method || 'email',
  });
}

/**
 * Track user SignIn event
 */
export function trackSignIn(userEmail) {
  track('sign_in', {
    email: userEmail,
  });
}

/**
 * Track when user abandons the cart DONE
 */
export function trackCartAbandoned(cart) {
  track('cart_abandoned', {
    // cart_id: cart.id,
    user_id: cart?.userId || null,
    total_items: cart.totalItems, //total number of products in cart
    total_price: cart.totalValue, // total price of all products
    abandoned_at: new Date().toISOString(),
    products: cart.items.map((product) => ({
      product_id: product?.productID,
      product_name: product?.productName,
      price: product?.fairAppPrice,
      quantity: product.quantity,
    })),
  });
}

/**
 * Track when a user signs out DONE
 */
export function trackSignOut(userId) {
  track('sign_out', {
    user_id: userId,
    signed_out_at: new Date().toISOString(),
  });
  reset();
}

/**
 * Track when a product is viewed DONE
 */
export function trackProductViewed(product) {
  track('product_viewed', {
    product_id: product?.productID,
    product_name: product?.productName,
    price: product?.fairAppPrice,
    category: product?.produtCategory?.parent_category?.name,
    sub_category: product?.produtCategory?.name,
  });
}

/**
 * Track when a category is viewed DONE
 */
export function trackCategoryViewed(category) {
  track('category_viewed', {
    category_name: category,
    viewed_at: new Date().toISOString(),
  });
}

/**
 * Track when a sub category is viewed DONE
 */
export function trackSubCategoryViewed(subCategory) {
  track('sub_category_viewed', {
    sub_category_name: subCategory,
    viewed_at: new Date().toISOString(),
  });
}

/**
 * Track checkout products
 */
export function trackCheckout(cart, user) {
  const totalAmount = cart.reduce((total, item) => {
    return (
      total +
      (item?.fairAppfairAppSalesPrice
        ? item?.fairAppfairAppSalesPrice
        : item?.price)
    );
  }, 0);
  track('checkout_started', {
    total_items: cart.length,
    payment_plan: cart[0].paymentPlan,
    total_amount: formatCurrency(totalAmount),
    user_name: `${user.firstName} ${user.lastName}`,
    user_email: user.email,
    user_phone: user.phoneNumber,
    started_at: new Date().toISOString(),

    // total_amount:  ,
    // currency: 'NGN',
  });
}

/**
 * Track when a user pays downpayment
 */
export function trackDownpaymentPaid(paymentData) {
  track('downpayment_paid', {
    order_id: paymentData?.orderId,
    transaction_id: paymentData?.transactionId,
    downpayment_amount: paymentData?.downpaymentAmount,
    total_order_amount: paymentData?.totalOrderAmount,
    payment_method: paymentData?.paymentMethod || 'paystack',
    user_id: paymentData?.userId,
    user_email: paymentData?.userEmail,
    currency: paymentData?.currency || 'NGN',
    paid_at: new Date().toISOString(),
    products:
      paymentData?.products?.map((product) => ({
        product_id: product?.productID,
        product_name: product?.productName,
        price: product?.fairAppPrice,
        quantity: product?.quantity,
      })) || [],
  });
}
/**
 * Track when a user's BVN is successfully verified || Account Verification
 */
export function trackBVNVerified(verificationData) {
  track('bvn_verified', {
    user_id: verificationData?.userId,
    user_email: verificationData?.userEmail,
    bvn: verificationData?.bvn ? '***masked***' : null, // Mask BVN for privacy
    verification_method: verificationData?.verificationMethod || 'manual',
    verification_status: verificationData?.verificationStatus || 'APPROVED',
    credit_eligibility: verificationData?.creditEligibility,
    verified_at: new Date().toISOString(),
  });
}
/**
 * Track when a user shares a product
 */
export function trackProductShared(shareData) {
  track('product_shared', {
    product_id: shareData?.productId,
    product_name: shareData?.productName,
    product_price: shareData?.productPrice,
    product_category: shareData?.productCategory,
    product_subcategory: shareData?.productSubcategory,
    share_method: shareData?.shareMethod, // 'native_share' or 'clipboard'
    share_url: shareData?.shareUrl,
    user_id: shareData?.userId,
    shared_at: new Date().toISOString(),
  });
}
